<script lang="ts">
	import { goto } from '$app/navigation';
	import { t } from '$lib/stores/i18n';
	import { currentBrowserTime } from '$lib/stores/time';
	import Bang from '$lib/svg/bang.svg.svelte';
	import { onMount } from 'svelte';
	import { cubicOut } from 'svelte/easing';
	import { slide } from 'svelte/transition';
	import { widgetBookingExpiresAt, widgetConfig } from '../stores';

	let remainingTime = $derived(
		$widgetBookingExpiresAt?.diff($currentBrowserTime, ['minutes', 'seconds'])
	);

	let expireSoon = $derived(remainingTime && remainingTime.minutes <= 0);
	let expired = $derived(
		remainingTime && remainingTime.minutes <= 0 && remainingTime.seconds <= 0
	);

	$effect(() => {
		if (expired) {
			goto(`/widget/${$widgetConfig.hash}`);
		}
	});

	let show = $state(false);
	onMount(() => {
		setTimeout(() => {
			show = true;
		}, 100);
	});
</script>

{#if remainingTime && show}
	<p
		transition:slide={{ duration: 1000, axis: 'y', delay: 400, easing: cubicOut }}
		class="flex items-center text-center justify-center gap-2 my-2 truncate {expireSoon
			? 'bg-error animate-pulse font-semibold '
			: 'bg-warning'} text-warning-on rounded-full py-1 px-2 transition-all"
	>
		{#if expireSoon}
			<Bang className="h-4 w-4 inline-block animate-ping" />
		{/if}
		{$t('widget-external.expires-at', {
			time:
				remainingTime.minutes.toString() +
				':' +
				Math.trunc(remainingTime.seconds).toString().padStart(2, '0')
		})}
	</p>
{/if}
